import { Component } from '@angular/core';

@Component({
  selector: '[nc-page-not-found]',
  template: '<div>Page not found :(</div>',
  standalone: false,
})
export class PageNotFoundComponent { }
